import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { sortBy, uniqueId } from 'lodash'
import React, { FC, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import { compile } from '../../../utils/search'

interface Props {
  appList: string[]
  callbackApps: (Apps: string[]) => void
  isClear?: boolean
}

const AddAppModule: FC<Props> = (props) => {
  const {
    appList,
    callbackApps,
    isClear,
  } = props

  const {
    task,
  } = useSelector((state: RootState) => state)

  const IMITATION = [
    "Chrome",
    "Edge",
    "Firefox",
  ]

  const [isSearchDisplay, setIsSearchDisplay] = useState(false)
  const [selectApps, setSelectApps] = useState<string[]>([])
  const [apps, setApps] = useState<string[]>([])
  const [searchAppWord, setSearchAppWord] = useState<string>("")

  const appsInit = useMemo(() => (
    task.taskLabelSettingDetail?.target_services
      ? [...task.taskLabelSettingDetail?.target_services, ...IMITATION]
      : task.taskProjectTemplateSettingDetail?.target_services || []
  ), [])

  const clickApp = (app: string) => {
    if (selectApps.includes(app)) {
      setSelectApps(selectApps.filter((id) => id !== app))
    } else {
      setSelectApps([...selectApps, app])
    }
  }

  const searchApp = (words: string) => {
    setSearchAppWord(words)
    if (!words) {
      setApps([...appsInit])
      return
    }
    const word = words.toLowerCase().split(/\s+/)
    const list = appsInit.filter((app) => {
      if (app === null) return false
      return (compile(word).test(app.toLowerCase())) || selectApps.includes(app)
    })
    setApps(sortBy(list, 'id'))
  }

  const resetApp = () => {
    setSearchAppWord("")
    setApps([...appsInit])
  }

  const openSearch = () => {
    setIsSearchDisplay(true)
  }

  const closeSearch = () => {
    setIsSearchDisplay(false)
    resetApp()
    callbackApps(selectApps)
  }

  useEffect(() => {
    setApps([...appsInit])
  }, [])

  useEffect(() => {
    setSelectApps(appList)
  }, [appList])

  useEffect(() => {
    if (!isClear) return
    setSelectApps([])
  }, [isClear])

  return (
    <>
      <div
        style={{
          backgroundColor: "#D5E8D4",
          color: "#82B366",
          borderRadius: "20px",
          padding: "4px 8px",
          display: "inline-block",
          marginRight: "8px",
          cursor: "pointer",
          position: "relative",
        }}
        onClick={() => openSearch()}
        role="none"
      >
        <FontAwesomeIcon icon={['fas', 'plus']} />
        &nbsp;
        追加
        {
          isSearchDisplay && (
            <div
              className={`search_box ${isSearchDisplay || 'none'}`}
              style={{
                top: "30px",
                right: "unset",
                border: "solid 1px #CCCCCC",
                color: "#666666",
              }}
            >
              <div
                className="search_detail"
                style={{
                  width: "300px",
                }}
              >
                <div className="category">
                  <div className="category_title">
                    アプリケーション
                    {
                      apps.length ? (
                        <div
                          className="select_reset"
                          role="none"
                          onClick={() => setSelectApps([])}
                        >
                          リセット
                        </div>
                      ) : (
                        <></>
                      )
                    }
                  </div>
                  <div className="search_area">
                    <FontAwesomeIcon
                      icon={['fas', 'search']}
                      className="icon"
                    />
                    <input
                      type="text"
                      placeholder="アプリを検索"
                      onChange={(event) => searchApp(event.target.value)}
                      value={searchAppWord}
                    />
                    {
                      searchAppWord && (
                        <button type="button" className="reset" onClick={resetApp}>
                          <FontAwesomeIcon icon={['far', 'times-circle']} />
                        </button>
                      )
                    }
                  </div>
                  {
                    !apps.length ? (
                      <div
                        style={{
                          backgroundColor: "#F7F7F7",
                          border: "solid 1px #CCCCCC",
                          borderRadius: "4px",
                          padding: "8px",
                        }}
                        onClick={() => window.open("https://qasee.zendesk.com/hc/ja/requests/new")}
                        role="none"
                      >
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: "8px",
                            fontWeight: "bold",
                            color: "#FF0000",
                          }}
                        >
                          選択できるアプリケーションがありませんでした
                        </div>
                        <div>
                          表示にないアプリケーションは登録することができます。
                        </div>
                        <div>
                          お手数ですが、
                          <span
                            style={{
                              color: "#4472BA",
                              textDecoration: "underline",
                            }}
                          >
                            カスタマーサポート
                          </span>
                          までご連絡ください。
                        </div>
                      </div>
                    ) : (
                      <>
                        <div
                          style={{
                            backgroundColor: "#F7F7F7",
                            border: "solid 1px #CCCCCC",
                            borderRadius: "4px",
                            padding: "8px",
                          }}
                          onClick={() => window.open("https://qasee.zendesk.com/hc/ja/requests/new")}
                          role="none"
                        >
                          <div>
                            表示にないアプリケーションは登録することができます。
                          </div>
                          <div>
                            お手数ですが、
                            <span
                              style={{
                                color: "#4472BA",
                                textDecoration: "underline",
                              }}
                            >
                              カスタマーサポート
                            </span>
                            までご連絡ください。
                          </div>
                        </div>
                        <div className="chip_list">
                          {
                            apps.map((app) => (
                              <button
                                type="button"
                                className={`chip ${selectApps.includes(app) ? "checked" : ""}`}
                                key={uniqueId()}
                                onClick={() => clickApp(app)}
                              >
                                {app}
                              </button>
                            ))
                          }
                        </div>
                      </>
                    )
                  }
                </div>
              </div>
            </div>
          )
        }
      </div>
      <div className={`close_screen ${isSearchDisplay || 'none'}`} role="presentation" onClick={() => closeSearch()} />
    </>
  )
}

AddAppModule.defaultProps = {
  isClear: false,
}

export default AddAppModule
